var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.0298C20 4.51656 15.5425 0.059082 10.0293 0.059082C4.51613 0.059082 0 4.51656 0 10.0298C0 15.0151 3.63636 19.1793 8.44575 19.8831V12.9623H5.92375V10.0298H8.44575V7.80102C8.44575 5.27902 9.91202 3.93005 12.1994 3.93005C13.3138 3.93005 14.4282 4.106 14.4282 4.106V6.56935H13.1378C11.9062 6.56935 11.4956 7.33181 11.4956 8.15292V10.0298H14.2522L13.9003 12.9623H11.5543V19.9418C16.3636 19.1793 20 15.0737 20 10.0298Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9003 12.9623L14.3695 10.0884H11.6129V8.21152C11.6129 7.44906 12.0234 6.62794 13.2551 6.62794H14.5454V4.1646C14.5454 4.1646 13.3724 3.98865 12.3167 3.98865C10.0293 3.98865 8.56301 5.39627 8.56301 7.85962V10.0297H6.04102V12.9623H8.56301V19.9417C9.09087 20.0004 9.61873 20.059 10.1466 20.059C10.6744 20.059 11.2023 20.0004 11.7302 19.9417V12.9623H13.9003Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.059082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9746f4c48206a4df94569c8e4dfbc960.svg";
export { ForwardRef as ReactComponent };